var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38100_2879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000273438 15.0469C0.29293 14.0168 0.856836 13.2068 1.86512 12.7596C2.2441 12.5916 2.63645 12.491 3.0548 12.491C9.2416 12.4924 15.4291 12.4868 21.6159 12.4952C23.4117 12.4974 24.8496 14.1188 24.7075 15.9223C24.6864 16.1874 24.5156 16.212 24.3356 16.2549C23.2331 16.522 22.1939 16.9481 21.2369 17.5528C18.1973 19.4745 16.3882 22.2174 16.0029 25.7949C15.6407 29.1551 16.6729 32.1047 18.9693 34.5994C19.0305 34.6662 19.1458 34.7274 19.1149 34.8223C19.0727 34.9495 18.9349 34.8968 18.8386 34.8968C13.5539 34.8989 8.26918 34.9024 2.98449 34.8933C1.7259 34.8912 0.547461 33.9694 0.12207 32.7087C0.0805859 32.587 0.0398047 32.4647 -0.000976562 32.3431C-0.000976562 26.5774 -0.000976562 20.8118 -0.000976562 15.0462L-0.000273438 15.0469ZM13.4034 23.7213C13.4034 22.9718 13.4125 22.2223 13.4006 21.4727C13.3907 20.8308 12.94 20.352 12.374 20.352C11.8087 20.352 11.3524 20.8329 11.3482 21.4735C11.3383 22.9613 11.3432 24.4484 11.3468 25.9362C11.3475 26.2392 11.441 26.517 11.6667 26.7286C11.9732 27.0162 12.3311 27.1245 12.7326 26.9585C13.1833 26.7722 13.3936 26.4087 13.3999 25.9355C13.4104 25.1979 13.4027 24.4596 13.4027 23.722L13.4034 23.7213Z",
    fill: "rgba(0, 0, 0, 0.38)",
    className: "bg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9457 36C24.8805 35.8172 23.8469 35.5388 22.8787 35.0396C19.6148 33.3563 17.6587 29.8097 17.9906 26.1598C18.3724 21.9614 21.6454 18.585 25.8628 18.0401C30.7636 17.4066 35.2903 20.8624 35.9526 25.7414C35.9618 25.8103 35.9843 25.8771 36.0004 25.9453V27.9844C35.9843 28.0526 35.9639 28.1194 35.9526 28.1883C35.3922 31.6371 33.4959 34.0397 30.2897 35.4122C29.5753 35.7181 28.8145 35.8601 28.0551 36H25.9457ZM23.1593 26.981C23.1593 27.5077 23.1557 28.035 23.16 28.5617C23.1635 29.0307 23.3568 29.3857 23.7738 29.6297C24.6429 30.1381 25.5042 30.6584 26.3641 31.1822C26.786 31.4389 27.1959 31.448 27.6192 31.1921C28.4904 30.6647 29.3615 30.1374 30.2397 29.6213C30.6433 29.3836 30.8367 29.0356 30.8388 28.5807C30.8451 27.5274 30.8451 26.4734 30.8388 25.4201C30.836 24.9814 30.6616 24.6312 30.27 24.3985C29.3742 23.8669 28.4819 23.3283 27.5889 22.7925C27.1896 22.5528 26.7944 22.5605 26.3964 22.801C25.5246 23.3269 24.6541 23.8557 23.7759 24.3703C23.3477 24.6214 23.1543 24.9842 23.1579 25.4707C23.1614 25.9742 23.1586 26.4776 23.1593 26.981Z",
    fill: "url(#paint0_linear_38100_2879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3593 0C14.4976 0.215156 15.5833 0.573047 16.5339 1.25648C18.5708 2.72039 19.6607 4.69688 19.7092 7.21898C19.7275 8.1675 19.7057 9.11742 19.7169 10.0666C19.7205 10.3352 19.6382 10.4393 19.3562 10.4365C18.2664 10.4238 17.1765 10.4245 16.0867 10.4365C15.8125 10.4393 15.7239 10.3472 15.7204 10.0723C15.7049 8.98383 15.7879 7.89328 15.6634 6.80625C15.5052 5.42883 14.248 4.21172 12.8833 4.01695C10.9876 3.74695 9.04983 5.08922 9.02733 7.43555C9.01889 8.31445 9.01678 9.19336 9.03014 10.0723C9.03436 10.3486 8.93803 10.4393 8.66452 10.4365C7.57468 10.4252 6.48483 10.433 5.39499 10.4309C5.23538 10.4309 5.03991 10.4625 5.04413 10.208C5.06382 8.90859 4.92178 7.60008 5.10811 6.31125C5.57428 3.06703 7.90514 0.675 11.1191 0.0632812C11.2105 0.0457031 11.3005 0.0210938 11.3905 0C12.0466 0 12.7033 0 13.3593 0Z",
    fill: "rgba(0, 0, 0, 0.38)",
    className: "bg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2177 26.8397C24.9653 26.1021 25.4673 25.709 26.1514 25.2858C26.7899 24.8913 27.2286 24.9244 27.8671 25.2907C28.5779 25.6985 28.8078 26.1499 28.8205 26.9641C28.8346 27.8402 28.5751 28.3275 27.8052 28.7444C27.2089 29.0679 26.7505 29.2113 26.2274 28.7233C26.2189 28.7156 26.207 28.7114 26.1971 28.7058C25.5442 28.3115 25.2177 27.6895 25.2177 26.8397Z",
    fill: "url(#paint1_linear_38100_2879)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38100_2879",
    x1: 36.0004,
    y1: 26.9826,
    x2: 17.9541,
    y2: 26.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#14B600",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E49",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38100_2879",
    x1: 28.821,
    y1: 27.0213,
    x2: 25.1514,
    y2: 27.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#14B600",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E49",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38100_2879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvl);
export default __webpack_public_path__ + "static/media/tvl.197124cec0118904b3eff2868237fd6f.svg";
export { ForwardRef as ReactComponent };